export const DURATION = {
    FOREVER: 'forever',
    SINGLE_USE: 'single_use',
    TEMPORAL: 'temporal',
};
